export default "<div class=\"row row-arreglos-01\">\r\n    <div class=\"img\"> \r\n    </div> \r\n</div>"